import plural from 'helpers/plural';

angular.module('filters').filter('membershipAccessWebsiteBookAndPayMessageFilter', ["$filter", function($filter) {
  return function(plan) {
    var classString, intervalNumberString, intervalString, intervalUnitString;
    classString = plural('classes', plan.classes_limit, true);
    intervalUnitString = plural(plan.classes_interval_unit, plan.classes_interval_number);
    intervalNumberString = plan.classes_interval_number > 1 ? plan.classes_interval_number : '';
    intervalString = plan.classes_unlimited || !plan.classes_interval_number || !plan.classes_interval_unit ? '' : `every ${intervalNumberString} ${intervalUnitString}`;
    switch (false) {
      case !plan.classes_unlimited:
        return "Allows: unlimited classes";
      case !plan.classes_limit:
        return `Allows: ${classString} ${intervalString}`;
      default:
        return '';
    }
  };
}]);
